import { Link, useNavigate } from 'react-router-dom';
import * as ROUTES from './../../../constants/routes';

const ForgetPasswordPage = () => {
  const navigate = useNavigate();
  const onSubmitClicked = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    navigate(ROUTES.LOGIN);
  };

  return (
    <>
      <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm space-y-10">
          <div>
            <img
              className="mx-auto h-32 w-auto"
              src="/logo512.png"
              alt="Trade-Tracker"
            />
            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
              Forgot your password?
            </h2>
            <p className="text-center mt-6 leading-1 text-gray-600">
              Enter the email address associated with your account and we'll
              send you a link to reset your password.
            </p>
          </div>

          <form className="space-y-4" onSubmit={onSubmitClicked}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email Address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="block w-full rounded-md border-0 px-3.5 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Continue
              </button>
            </div>
          </form>
          <p className="text-center text-sm leading-6 text-gray-500">
            Not a member?{' '}
            <Link
              to={ROUTES.SIGN_UP}
              className="font-semibold text-indigo-600 hover:text-indigo-500"
            >
              Sign up now
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default ForgetPasswordPage;
